export const EDITOR_MODES = {
  SET_SCALE: 'SET_SCALE',
  CONTOUR_SELECTION: 'CONTOUR_SELECTION',
};

export const SCALE_MODES = {
  LINE_LENGTH: 'LINE_LENGTH',
  MEASUREMENT: 'MEASUREMENT',
};
